import { apiGet, apiSend } from './api.js';
import type {
  SyntheticProbe,
  SyntheticProbeType,
  FleetSloMetric,
  AnomalyEvent,
  AnomalyStatus,
} from '@hospasense/contracts';

export async function fetchSyntheticProbes(): Promise<SyntheticProbe[]> {
  const data = await apiGet<{ items: SyntheticProbe[] }>('/api/v1/reliability/probes');
  return data.items;
}

export async function createSyntheticProbe(input: {
  name: string;
  probeType: SyntheticProbeType;
  targetInstallationId?: string | null;
  targetUrl?: string | null;
  intervalSeconds?: number;
  timeoutMs?: number;
}): Promise<SyntheticProbe> {
  return apiSend<SyntheticProbe>('POST', '/api/v1/reliability/probes', input);
}

export async function fetchFleetSlos(): Promise<FleetSloMetric[]> {
  const data = await apiGet<{ items: FleetSloMetric[] }>('/api/v1/reliability/slos');
  return data.items;
}

export async function fetchAnomalyEvents(status?: AnomalyStatus): Promise<AnomalyEvent[]> {
  const query = status ? `?status=${status}` : '';
  const data = await apiGet<{ items: AnomalyEvent[] }>(`/api/v1/reliability/anomalies${query}`);
  return data.items;
}

export async function resolveAnomalyEvent(
  id: string,
): Promise<{ success: boolean; message: string }> {
  return apiSend<{ success: boolean; message: string }>(
    'POST',
    `/api/v1/reliability/anomalies/${id}/resolve`,
  );
}
